<template>
  <div class="localization-selector"
       tabindex="0"
       @click="isOpen = !isOpen"
       @focusout="isOpen = false"
  >
    <div class="localization-selector__label">
      {{ currentLocale }}

      <app-icon icon="arrow-down-triangle"
                class="localization-selector__icon"
                :class="{'localization-selector__icon--is-active': isOpen}"
      />
    </div>

    <transition name="fade">
      <div v-show="isOpen"
           class="localization-selector__dropdown"
      >
        <button v-for="locale in availableLocales"
                :key="locale"
                class="localization-selector__item"
                @click.stop="setLocale(locale)"
        >
          {{ locale }}
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "LocalizationSelector",
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale
    },
    availableLocales() {
      return this.$i18n
        .availableLocales
        .filter((l) => l !== this.currentLocale)
    }
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale
    }
  }
}
</script>

<style lang="scss">
.localization-selector {
  position: relative;
  margin: 0 12px;
  color: $app-primary-color;
  font-weight: 500;
  padding: 4px 8px;
  text-transform: uppercase;
  user-select: none;
  cursor: pointer;

  &__icon {
    transition: .3s;
    margin-bottom: 1px;

    &--is-active {
      transform: rotate(180deg);
    }
  }

  &__dropdown {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    padding: 23px 7px 3px;
    border: 1px solid $app-primary-color;
    display: flex;
    flex-direction: column;
    z-index: 5;
  }

  &__item {
    background: $app-block-color;
    font-weight: inherit;
    font-size: inherit;
    text-transform: inherit;
    font-family: inherit;
    color: inherit;
    border: none;
    border-top: 1px solid $app-primary-color;
    cursor: pointer;
    text-align: left;
    padding: 2px 0 1px;
  }

}
</style>